export default __webpack_public_path__ + "static/media/wave-02.1989a97b.png";